module.exports = __webpack_public_path__ + "c0546a52cb5e19dbc799cc787a3d3267.png";